<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.orderDetail.title')}}
		</div>
		<div class="infoArea">
			<div class="betweenText">
				<div>{{$t('mypages.orderDetail.platform_order_no')}}{{orderInfo.order_no}}</div>
				<div>{{$t('mypages.orderDetail.pay_method')}}{{$t('mypages.orderDetail.pay_online')}}   {{$t('mypages.orderDetail.order_status')}}{{ orderInfo.order_state==0 ? $t('mypages.order.status_pending_payment') : $t('mypages.order.status_received') }}</div>
			</div>
			<div class="userInfos">
				<div class="userInfo">
					<div class="infoTitle">{{$t('mypages.orderDetail.section_receive_info')}}</div>
					<ul>
						<li>{{$t('mypages.orderDetail.label_recipient')}}{{orderInfo.receive_name}}</li>
						<li>{{$t('mypages.orderDetail.label_recipient_phone')}}{{orderInfo.receive_phone}}</li>
						<li>{{$t('mypages.orderDetail.label_recipient_address')}}{{orderInfo.address}}</li>
					</ul>
				</div>
				<div class="piaoInfo">
					<div  class="infoTitle">{{$t('mypages.orderDetail.section_invoice_info')}}</div>
					<ul>
						<li>{{$t('mypages.orderDetail.label_invoice_type')}}{{ memberInfo.invoice_type ==1 ? $t('mypages.order.invoice_special') : $t('mypages.order.invoice_general') }}</li>
						<li>{{$t('mypages.orderDetail.label_invoice_head')}}{{memberInfo.invoice_head}}</li>
						<li>{{$t('mypages.orderDetail.label_tax_no')}}{{memberInfo.invoice_taxno}}</li>
					</ul>
				</div>
			</div>
			
				<div class="remark">
					<div class="remarkTitle">{{$t('mypages.orderDetail.section_remark')}}</div>
					<ul>
						<li>{{$t('mypages.orderDetail.label_expect_delivery')}}{{ orderInfo.receive_type==1 ? $t('mypages.orderDetail.delivery_all_days') : $t('mypages.orderDetail.delivery_workday_only') }}</li>
						<li>{{$t('mypages.orderDetail.label_purchase_order_no')}}{{orderInfo.sale_no}}</li>
						<li>{{$t('mypages.orderDetail.label_order_memo')}}{{orderInfo.memo==''? $t('mypages.orderDetail.memo_none') : orderInfo.memo}}</li>
						<li>{{$t('mypages.orderDetail.label_attachments')}}:
							<div class="photos">
								<img  :src="item" class="photoSize" v-for="(item,index) in orderInfo.memo_images"/>
							</div>
						</li>
					</ul>
				</div>
		</div>
		
		<table class="orderLists">
			<thead>
				<th><div>{{$t('mypages.orderDetail.th_product_info')}}</div></th>
				<th><div>{{$t('mypages.orderDetail.th_spec')}}</div></th>
				<th><div>{{$t('mypages.orderDetail.th_lead_time')}}</div></th>
				<th><div>{{$t('mypages.orderDetail.th_quantity')}}</div></th>
				<th><div>{{$t('mypages.orderDetail.th_subtotal_incl_tax')}}</div></th>
				<th><div>{{$t('mypages.orderDetail.th_status')}}</div></th>
			</thead>
			<tbody>
				<tr v-for="(item,index) in orderInfo.detail_list">
					<td>
						<div class="orderlist orderTitle">
							<div class="orderTitle titleFlex">
							<img  :src="item.sku_image"/>
							<div class="infoDetail ">
								<div class="infoText">{{item.product_name}}</div>
								<div class="grayText">{{item.cate_name}}</div>
								<div class="price">￥{{item.sale_price}}</div>
							</div>
							</div>
							
						</div>
					</td>
					<td>
						<div class="infolist orderType" style="line-height: 30px;">
							{{item.sku_text}}
						</div>
					</td>				
					<td >
						<div class="orderStatus amountTd">
							<div class="statusText">{{$t('mypages.orderDetail.lead_time_contact')}}</div>
						</div>
					</td>
					<td >
						<div class="orderNum textCenter">{{item.number}}</div>
					</td>
					<td>
						<div class="orderAmount amountTd">
							<div class="redPrice">￥{{item.total_amount}}</div>
							<div class="grayText">(含税费:￥{{item.tax_price*item.number}})</div>
						</div>
					</td>
				
					<td rowspan="5" v-if="index == 0" class="setBorder"> 
						<div class="orderToolTd amountTd">
							<div class="timeText"><span>{{ orderInfo.order_state==0 ? $t('mypages.order.status_pending_payment') : $t('mypages.order.status_received') }}</span></div>
						</div>
					</td>
				</tr>	
			</tbody>
						
		</table>
		
		<div class="cardArea">
			<div class="settlement">
					<div class="settlementTitle">{{$t('mypages.orderDetail.settlement_total_count')}}</div>
				<div class="settlementVal">{{orderInfo.productcount}}</div>
			</div>
			<div class="settlement">
					<div class="settlementTitle">{{$t('mypages.orderDetail.settlement_total_amount')}}</div>
				<div class="settlementVal">￥{{orderInfo.order_amount}}</div>
			</div>
			<div  class="settlement">
					<div class="settlementTitle">{{$t('mypages.orderDetail.settlement_tax')}}</div>
				<div class="settlementVal">￥{{orderInfo.order_amount-orderInfo.product_amount-orderInfo.express_price}}</div>
			</div>
<!-- 			<div  class="settlement">
				<div class="settlementTitle">优惠券抵用：</div>
				<div class="settlementVal">-￥100.00</div>
			</div> -->
			<div  class="settlement">
					<div class="settlementTitle">{{$t('mypages.orderDetail.settlement_shipping')}}</div>
				<div class="settlementVal">￥{{orderInfo.express_price}}</div>
			</div>
			<div class="settlementBtns" v-if="orderInfo.order_state==0">
					<div class="settlementText">{{$t('mypages.orderDetail.settlement_payable')}}<span>￥{{orderInfo.order_amount}}</span></div>
					<div class="settlementBtn" v-if="!compareResult" @click="submitOrder()">{{$t('mypages.orderDetail.btn_pay_now')}}</div>
			</div>
		</div>			
		
	</div>
</template>

<script>
	export default{
		components:{},
		props:['id'],
		data() {
			return {
				orderId: 0,
				orderInfo:{},
				compareResult:false,
				memberInfo:{},
			}
		},
		created() {
			this.orderId = this.id;
			this.getOrderInfo();
			this.GetMemberInfo();
			
			
		},
		methods:{
			getOrderInfo()
			{
				this.$scUtil.axiosPost(this, 'OrderApi/GetOrderInfo', {
					orderId: this.orderId,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						this.orderInfo = res.data[0];
						  this.isBeforeCurrentDate(this.orderInfo.endtime)
						}
						//console.log(JSON.stringify(this.orderInfo))
				});
			},
			isBeforeCurrentDate(dateInfo) {
			      const currentDate = new Date();
			      const dateToCompare = new Date(dateInfo);
			      return this.compareResult=(currentDate > dateToCompare);
			},
			submitOrder()
			{
				this.$router.push({ path:'/pay' , query:{id:this.orderId}});
			},
			GetMemberInfo()
			{
				this.memberInfo=[];
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						//console.log(JSON.stringify(this.memberInfo))
					}
				
				});
			}
			
		}
	}
</script>

<style scoped>
	.rightInner{
		width: 958px;
		
	}
	
	.infoArea{
		background-color: #fff;
	}
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	.betweenText{
		color: #000000;
		font-size: 12px;
		display: flex;
		justify-content: space-between;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		height: 46px;
		align-items: center;
	}
	
	.userInfos{
		display: flex;
		padding: 0 20px;
		width: 100%;
		box-sizing: border-box;
	}
	
	.userInfo{
		width: 336px;
		border-right: 1px solid #e2e2e2;
	}
	
	.piaoInfo{
		flex: 1;
		padding-left: 72px;
		box-sizing: border-box;
	}
	
	ul li{
		list-style: none;
	}
	
	.infoTitle,.remarkTitle{
		font-size: 13px;
		color: #666666;
		line-height: 35px;
	}
	
	.piaoInfo ul li,
	.userInfo ul li,
	.remark ul li{
		font-size: 13px;
		color: #333333;
		line-height: 30px;
		display: flex;
	}
	
	
	.remark{
		display: flex;
		flex-direction: column;
		padding: 0 20px;
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #e2e2e2;
		margin-top: 25px;
		padding-top: 25px;
	}
	
	.photoSize{
		width: 68px;
		height: 68px;
		margin: 0 15px 15px 0;
	}
	
	.photos{
		margin-top: 10px;
	}
	
	.orderLists{
		width: 100%;
		background-color: #fff;
		margin-top: 13px;
	}

.orderHead{
		color: #333333;
		font-size:13px;
		text-align: center;
		display: flex;
		align-items: center;
		height: 50px;
		background-color: #fff;
		padding-left: 20px;
		box-sizing: border-box;
	}
	
	.orderTitle{
		width: 290px;		
	}
	
	.orderType{
		width: 204px;
	}
	
	.orderNum{
		width: 80px;
	}
	
	.orderAmount{
		width: 137px;
	}
	
	.orderStatus{
		width: 98px;
	}
	
	.orderTool{
		width: 149px;
	}
	
	.orderBody{
		margin-top: 20px;
		background-color: #fff;
	}
	
	.orderInfoTitle{
		font-size: 12px;
		color: #333333;
		height: 65px;
		display:flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		padding-left: 21px;
		line-height: 20px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.orderInfoTitle span{
		margin:0 24px;
	}
	
	
	.orderlist{
		display: flex;
		align-items: center;		
		padding: 20px 0 20px 0;
		box-sizing: border-box;
	}
	
	.orderlist:nth-last-child(1){
		border-bottom: none;
	}
	
	
	.orderLists thead{
		border-bottom: 1px solid #e2e2e2;
		height: 50px;
		font-size: 13px;
		color: #333333;
	}
	
	.infoDetail{
		word-break: break-all;	
		line-height: 20px;
	}
	
	.orderlist img{
		width: 79px;
		height: 79px;
		border: 1px solid #e7e7e7;
		margin-right: 15px;
	}
	
	.infoText{
		font-size: 13px;
		color: #000000;
	}
	
	.grayText{
		font-size: 12px;
		color: #888888;
	}
	
	.infolist{
		font-size: 12px;
		color: #333333;
		line-height: 20px;
		padding-left: 20px;
		box-sizing: border-box;
	}
	
	.price{
		color: #db050f;
		font-size: 14px;
		font-weight: bolder;
	}
	
	.infolist p{
		width: 100%;
		text-align: left;
	}
	
	.titleFlex{
		display: flex;
		padding-right:30px;
		box-sizing: border-box;
		padding-left: 20px;
	}
	
	.textCenter{
		text-align: center;
	}
	
	.amountTd{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.redPrice{
		font-size: 14px;
		color: #db050f;
	}
	
	table{
		border-collapse: collapse;
	}
	
	table tr td{
		
		border-top: none;
	}
	
	.statusText{
		font-size: 13px;
		color: #333333;
	}
	
	.moreText{
		font-size: 13px;
		color: #0380fe;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.orderToolTd{
		width: 144px;
	}
	
	.timeText span{
		font-size: 13px;
		color: #0380fe;
		font-weight: bolder;
	}
	
	table tr{
		border-bottom: 1px solid #e7e7e7;
	}
	
	table tr:nth-last-child(1){
		border-bottom: 0px solid transparent;
	}
	
	.setBorder{
		border-left: 1px solid #e7e7e7;
	}
	
	.cardArea{
		width: 100%;
		background-color: #fff;
		padding: 14px 14px 0 14px;
		box-sizing: border-box;
		margin-top: 13px;
	}

	
	.settlement{
		display: flex;
		align-items: center;
	}
	
	.settlementTitle{
		flex: 1;
		text-align: right;
		font-size: 13px;
		color:#000000;
		line-height: 35px;
	}
	
	.settlementVal{
		width: 127px;
		text-align: right;
		font-size: 13px;
		color: #db050f;
		line-height: 35px;
		margin-right: 15px;
	}
	
	.settlementBtns{
		height: 92px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		border-top: 1px solid #e2e2e2;
	}
	
	.settlementText{
		font-size: 15px;
		color: #000000;
	}
	
	.settlementText span{
		font-size: 20px;
		color: #db050f;
		font-weight: bolder;
	}
	
	.settlementBtn{
		width: 142px;
		height: 44px;
		background: #0380fe;
		border-radius: 5px;
		color: #fff;
		font-size: 18px;
		font-weight: bolder;
		margin-left: 25px;
		text-align: center;
		line-height: 44px;
	}
</style>